import { PodcastItemModel } from '@_types/organisms';
import Icon from '@atoms/icons/Icon';

const PodcastItem = ({ title }: PodcastItemModel) => {
  return (
    <a className="kf-o-podcasts-item" href={title?.url} rel="noreferrer" target="_blank">
      <div className="kf-o-podcasts-item__inner">
        <div className="kf-o-podcasts-item__icon">
          <Icon iconPath="#kf-play" viewBoxHeight={80} viewBoxWidth={80} />
        </div>
        <h3 className="kf-o-podcasts-item__title">{title?.text}</h3>
      </div>
    </a>
  );
};

export default PodcastItem;
